import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Refresh = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M5 4V7.25C5 7.66421 5.33579 8 5.75 8H8.75M19.0118 20V16.75C19.0118 16.3358 18.6761 16 18.2618 16H15.0118M4 12C4 16.4183 7.58172 20 12 20C14.6362 20 17.0303 18.7249 18.5 16.7578M20 12C20 7.58172 16.4183 4 12 4C9.36378 4 6.96969 5.27512 5.5 7.24224'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 3.25C5.41421 3.25 5.75 3.58579 5.75 4V5.81663C7.35472 4.2299 9.58428 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75C19.5858 12.75 19.25 12.4142 19.25 12C19.25 7.99594 16.0041 4.75 12 4.75C9.81 4.75 7.80408 5.71987 6.45868 7.25H8.75C9.16421 7.25 9.5 7.58579 9.5 8C9.5 8.41421 9.16421 8.75 8.75 8.75H5.75C4.92157 8.75 4.25 8.07843 4.25 7.25V4C4.25 3.58579 4.58579 3.25 5 3.25ZM4 11.25C4.41421 11.25 4.75 11.5858 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C14.19 19.25 16.1959 18.2801 17.5413 16.75H15.0118C14.5976 16.75 14.2618 16.4142 14.2618 16C14.2618 15.5858 14.5976 15.25 15.0118 15.25H18.2618C19.0903 15.25 19.7618 15.9216 19.7618 16.75V20C19.7618 20.4142 19.4261 20.75 19.0118 20.75C18.5976 20.75 18.2618 20.4142 18.2618 20V18.1716C16.6563 19.7653 14.4217 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12C3.25 11.5858 3.58579 11.25 4 11.25Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
